import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { useMemo as c } from "react";
import { p as v, q as N } from "../../index-CExbjDCE.js";
import { Button as n } from "../Button/Button.js";
import "../Button/ButtonBase.js";
import "../Button/theme.js";
import { periodDatePickerTheme as u } from "./theme.js";
import { MONTHS as g } from "./types.js";
import { Select as p } from "../Select/Select.js";
const O = ({
  viewDate: l,
  onNavigate: s,
  showMonthYearSelector: h,
  onMonthYearChange: a,
  yearRange: o,
  disablePrev: d,
  disableNext: f
}) => {
  const i = c(
    () => g.map((e, b) => ({
      label: e,
      value: String(b)
    })),
    []
  ), m = c(
    () => o.map((e) => ({
      label: String(e),
      value: String(e)
    })),
    [o]
  );
  return /* @__PURE__ */ t("div", { className: u.popover.header.base, children: [
    /* @__PURE__ */ r(
      n,
      {
        onClick: () => s("prev"),
        className: "h-8 w-8",
        color: "outline",
        size: "xs",
        disabled: d,
        children: /* @__PURE__ */ r(v, { className: "h-4 w-4" })
      }
    ),
    h ? /* @__PURE__ */ t(
      "div",
      {
        className: u.popover.header.selector.base,
        children: [
          /* @__PURE__ */ r(
            p,
            {
              value: i[l.getMonth()],
              onChange: (e) => {
                e && typeof e == "object" && "value" in e && a(
                  Number(e.value),
                  l.getFullYear()
                );
              },
              options: i,
              isSearchable: !0,
              className: "min-w-32 z-100"
            }
          ),
          /* @__PURE__ */ r(
            p,
            {
              value: m.find(
                (e) => e.value === String(l.getFullYear())
              ),
              onChange: (e) => {
                e && typeof e == "object" && "value" in e && a(
                  l.getMonth(),
                  Number(e.value)
                );
              },
              options: m,
              isSearchable: !0,
              className: "min-w-20 z-100"
            }
          )
        ]
      }
    ) : /* @__PURE__ */ r("div", { className: "flex-1" }),
    /* @__PURE__ */ r(
      n,
      {
        onClick: () => s("next"),
        className: "h-8 w-8",
        color: "outline",
        size: "xs",
        disabled: f,
        children: /* @__PURE__ */ r(N, { className: "h-4 w-4" })
      }
    )
  ] });
};
export {
  O as Header
};
